import {createApp} from 'vue'
import AccountVue from './Account.vue'
import '@aws-amplify/ui-vue';
import { createStore } from 'vuex'
import actRouter from "./ActRouter";
import {IonicVue} from "@ionic/vue";
import axios from "axios";
import AmplifyVue from '@aws-amplify/ui-vue';
import {Amplify} from "aws-amplify";
// import moment from "moment";
import {applyPolyfills, defineCustomElements} from '@aws-amplify/ui-components/loader';


/* Core CSS required for Ionic components to work properly */
import '@ionic/vue/css/core.css';


/* Basic CSS for apps built with Ionic */
import '@ionic/vue/css/normalize.css';
import '@ionic/vue/css/structure.css';
import '@ionic/vue/css/typography.css';

/* Optional CSS utils that can be commented out */
import '@ionic/vue/css/padding.css';
import '@ionic/vue/css/float-elements.css';
import '@ionic/vue/css/text-alignment.css';
import '@ionic/vue/css/text-transformation.css';
import '@ionic/vue/css/flex-utils.css';
import '@ionic/vue/css/display.css';

/* Theme variables */
import '../theme/variables.css';
/* Common CSS */
import './styles.css';

const store = createStore({
  state: {
    leadInfo: null
  },
  mutations: {
    leadInfo (state, leadInfo) {
      state.leadInfo = leadInfo;
    },
    pref_program (state, pp) {
      // @ts-ignore
      state.leadInfo.lead.cf.pref_program = pp;
    }
  }
})

applyPolyfills().then(() => {
  defineCustomElements(window);
});

//todo filters
// Vue.filter('formatDate', function(value) {
//   if (value) {
//     return moment(String(value)).format('MM/DD/YYYY hh:mm')
//   }
// });
//
// Vue.filter('formatTimeId', function(value,arg) {
//   if (value) {
//     return moment(value).format(arg || 'yyyy-MMM-DD hh:mm A')
//   }
//   return null
// });


let initApp = () => {
  axios.get('/assets/config/config.json').then( res => {
    // Vue.prototype.$config = res.data;

    console.log(res.data.amplifyConfig)
    Amplify.configure(res.data.amplifyConfig)

    const app = createApp(AccountVue)
      .use(AmplifyVue)
      .use(IonicVue)
      .use(store)
      .use(actRouter);

    // console.log(process.env.BASE_URL)
    app.provide('$config', res.data);

    actRouter.isReady().then(() => {
      app.mount('#account-vue');
    });
  })
}

initApp();

